import { NgModule } from '@angular/core';
import { CrmOwnedContactIconComponent } from './crm-owned-contact-icon.component';
import { CommonModule } from '@angular/common';
import {  MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    imports: [
        CommonModule,
        MatTooltipModule,
    ],
    declarations: [CrmOwnedContactIconComponent],
    exports: [CrmOwnedContactIconComponent],
})
export class CrmowedContactIconModule {

}
